<template>
  <div>
    <!-- 商品备注 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="$parent.commodityNoteDialogVisible" width="856px" center
      :title="title">
      <div class="content">
        <div class="list">
          <div class="item">
            <!-- 业务备注 -->
            <h6>{{ $t("message.serviceRemarks") }}</h6>
            <!-- 备注 -->
            <div class="remark">
              {{ commodityNoteData.y_remark }}
            </div>
          </div>
          <div class="item">
            <!-- 采购备注 -->
            <h6>{{ $t("message.purchasingNotes") }}</h6>
            <!-- 备注 -->
            <div class="remark">
              {{ commodityNoteData.g_remark }}
            </div>
          </div>
          <div class="item">
            <!-- 配货备注 -->
            <h6>{{ $t("message.distributionRemarks") }}</h6>
            <!-- 备注 -->
            <div class="remark">
              {{ commodityNoteData.p_remark }}
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    commodityNoteData: {
      type: Object,
    },
    title: {
      type: String
    }
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
.content {
  padding: 0 15px;

  .list {
    display: flex;

    .item {
      flex: 1;
      margin-right: 40px;
      padding-bottom: 25px;
      background: #ffffff;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
      border-radius: 4px;

      &:nth-last-child(1) {
        margin-right: 0;
      }

      h6 {
        height: 40px;
        padding-left: 10px;
        line-height: 40px;
        background: #f8f8f8;
      }

      .remark {
        margin: 12px 16px;
        padding: 15px 12px;
        height: 160px;
        border: 1px solid #dcdfe6;
      }
    }
  }
}
</style>